import { render, staticRenderFns } from "./cipVtcMapImport.vue?vue&type=template&id=74bc0d4c"
import script from "./cipVtcMapImport.vue?vue&type=script&lang=js"
export * from "./cipVtcMapImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports